module.exports = __webpack_public_path__ + "img/1.2dab9f4a.jpg";